<template>
  <router-view />
</template>

<script>
import db from "@/utils/localStorage";
import { mapState } from "vuex";
import themeColor from "@/assets/styles/themeColor";
import { getHashSearchParam } from "@/utils/fn";
//import { decompress } from '@/utils/lz-string'

export default {
  name: "globalControl",
  created() {
    this.getApiSrc()
    this.setToken()
    this.drakCompile();
    this.getBackUrl();
    this.getLanguageType()
    this.changeDocumentTitle();
    if (getHashSearchParam('token')) {
      db.save('URL_PARAMS', location.href.split('?')[1])
    }
    this.cleanUrlParams()
    

  },
  watch: {
    theme: {
      immediate: true, // 首次加载的时候执行函数
      handler() {
        this.themeHandle();
      },
    },
    // "user.isLogin": {
    //   immediate: true, // 首次加载的时候执行函数
    //   handler(isLogin) {
    //     if (isLogin) {
    //     //   this.$store.dispatch("user/getBal");
    //     }
    //   },
    // },
  },
  computed: {
    theme() {
      return this.common.theme || "light";
    },
    ...mapState(["common", "user"]),
  },
  methods: {
    changeDocumentTitle() {
      document.title = this.$t('documentTitle')
    },
    getLanguageType() {
      const languageType = getHashSearchParam('language') || db.get("languageType", "")
      if (languageType) {
        db.save('languageType', languageType)
        this.$store.commit("common/SET_DATA", {name: 'languageType' ,data: languageType});
        this.$i18n.locale = (languageType == 'CMN' || languageType == 'ZHO') ? 'zh' : 'en'
        if(languageType == "VIE"){
          this.$i18n.locale = 'vn'
        }
      }
    },
    getApiSrc() {
      const apiSrc = decodeURIComponent(getHashSearchParam("apiSrc"))
      if (apiSrc && apiSrc != 'null') {
        db.save('apiSrc', apiSrc)
      }
    },
    getBackUrl() {
      const p = getHashSearchParam("url")
      const backUrl = p ? encodeURI(p) : db.get("backUrl", "");
      if (backUrl) {
        db.save("backUrl", backUrl);
        this.$store.commit("common/SET_DATA", {
          name: "backUrl",
          data: backUrl,
        });
      }
    },
    setToken() {
      const _token = getHashSearchParam('token') || db.get("token", "")
      const _nickname = getHashSearchParam('nickname') || db.get("nickname", "")
      if (_token) {
        this.$store.commit("common/SET_TOKEN", _token);
      }
      if (_nickname) {
        this.$store.commit("common/SET_NICKNAME", _nickname);
      }
    },
    drakCompile() {
      const theme = getHashSearchParam('color') || db.get("theme", "")
      console.log(theme, "theme");
      if (theme) {
        this.$store.commit("common/SET_THEME", theme);
      }
    },
    themeHandle(){
      if(this.theme && themeColor[this.theme]){
        let themeColorObj = themeColor[this.theme];
        Object.keys(themeColorObj).forEach(key => {
          document.getElementsByTagName('html')[0].style.setProperty(key, themeColorObj[key])
        })

        // html 添加 class
        document.documentElement.className = `${this.theme}-theme`;
      }
    },
    cleanUrlParams() {
      try {
        const url = window.location.href
        const hashIndex = url.indexOf('#')
        const hash = hashIndex !== -1 ? url.substring(hashIndex + 1) : ''
        const searchIndex = hash.indexOf('?')
        if (searchIndex !== -1) {
          const hashRoute = hash.substring(0, searchIndex)
          const cleanHash = hashRoute ? `#${hashRoute}` : '#'
          const cleanUrl = url.substring(0, hashIndex !== -1 ? hashIndex : url.length) + cleanHash
          window.history.replaceState(null, '', cleanUrl)
        }
      } catch(err) {
        console.log('[err]', err)
      }
    }
  },
};
</script>

<style>
</style>